import { styles } from 'consts';
import styled from 'styled-components';

import ILanguageOptionProps from './Header.types';

const { textColorGray, fontMBank, secondaryBlack } = styles;

const Container = styled.div<{ $hasAdditionalButtons: boolean }>`
  margin: 0.5rem 0.5rem 0.725rem;

  @media (min-width: 768px) {
    margin: 0 1.5rem 1.8125rem;
    ${props =>
      props.$hasAdditionalButtons &&
      ` 
       margin: 0 1.5rem 0;
  `}
  }
`;

const ContainerHeader = styled.header`
  display: flex;
  flex-wrap: wrap;

  .logo-desktop {
    height: 2.3rem;
    object-fit: contain;
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  }

  .logo-mobile {
    height: 1.125rem;
    width: 3.375rem;
    object-fit: contain;
    display: block;

    @media (min-width: 768px) {
      display: none;
    }
  }
`;

const HeaderText = styled.div`
  display: none;
  margin-left: auto;

  @media (min-width: 768px) {
    display: flex;
  }
`;

const LanguageSelect = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  padding-top: 0.6rem;
  @media (min-width: 768px) {
    padding-top: 0rem;
  }
`;

const LanguageOption = styled.button.attrs<ILanguageOptionProps>(
  ({ languageKey }: ILanguageOptionProps) =>
    ({
      'data-locale': languageKey,
    } as Partial<React.ButtonHTMLAttributes<HTMLButtonElement>>)
)<ILanguageOptionProps>`
  background: none;
  color: ${textColorGray};
  text-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
  font-family: ${fontMBank};
  font-size: 0.75rem;
  font-weight: 300;
  letter-spacing: 0.0375rem;
  text-align: right;
  color: #afafaf;
  cursor: pointer;
  outline: none;

  &.active {
    font-weight: 500;
    color: #d2d2d2;
  }

  @media (min-width: 768px) {
    font-size: 0.875rem;
  }

  &:after {
    content: '|';
    font-weight: 300;
    padding: 0 0.2rem 0 0.2rem;
  }
  &:last-child:after {
    content: '';
    padding: 0;
  }
`;

const GoBackButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 2rem;
  margin-top: 0.5rem;

  @media (min-width: 768px) {
    margin-top: 1.5rem;
  }

  button {
    background: none;
    color: ${secondaryBlack};

    padding-bottom: 0.2rem;
    font-size: 0.75rem;

    @media (min-width: 768px) {
      color: #d2d2d2;
      font-weight: 300;
      font-size: 0.875rem;
    }
  }
`;

const GoBackButtonRow = styled.div`
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    gap: 0.05rem;
    cursor: pointer;
    
    img {
        width: 1.3rem;
        height: 1.3rem;
    }

    .chevron-left-desktop {
        display: none;

        @media (min-width: 768px) {
            display: block;
        }
    }

    .chevron-left-mobile {
        display: block;

        @media (min-width: 768px) {
            display: none;
        }
`;

export { Container, ContainerHeader, HeaderText, LanguageSelect, LanguageOption, GoBackButtonWrapper, GoBackButtonRow };
